import type { ListBatchJobItemsParams } from "../../../../../lib/corpusApi";

export type AdmissionRecheckTabKey =
  "candidates" | "escalated" | "failed" | "revoked" | "dismissed" | "admitted";

export interface AdmissionRecheckTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "review" | "outcome">;
  /** Whether this tab's items are still awaiting a review decision — gates multi-select and the
   *  per-row Revoke/Keep actions. Reviewed/admitted/failed tabs are read-only history. */
  reviewable: boolean;
  /** Whether the rejection-code filter control is shown for this tab. Only meaningful on tabs
   *  that can hold items with a rejection finding. */
  rejectionFilterable: boolean;
}

/** One tab per admission_recheck review queue. Order here is display order. */
export const ADMISSION_RECHECK_TABS: Record<AdmissionRecheckTabKey, AdmissionRecheckTabConfig> = {
  candidates: {
    label: "Revocation candidates",
    apiFilters: { review: "open", outcome: "rejected" },
    reviewable: true,
    rejectionFilterable: true,
  },
  escalated: {
    label: "Escalated",
    apiFilters: { review: "open", outcome: "escalated" },
    reviewable: true,
    rejectionFilterable: true,
  },
  failed: {
    label: "Failed",
    apiFilters: { status: "failed" },
    reviewable: false,
    rejectionFilterable: false,
  },
  revoked: {
    label: "Revoked",
    apiFilters: { review: "applied" },
    reviewable: false,
    rejectionFilterable: true,
  },
  dismissed: {
    label: "Dismissed",
    apiFilters: { review: "dismissed" },
    reviewable: false,
    rejectionFilterable: true,
  },
  admitted: {
    label: "Admitted",
    apiFilters: { outcome: "admitted" },
    reviewable: false,
    rejectionFilterable: false,
  },
};

export const ADMISSION_RECHECK_TAB_ORDER: AdmissionRecheckTabKey[] = [
  "candidates",
  "escalated",
  "failed",
  "revoked",
  "dismissed",
  "admitted",
];
